import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Equipment } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/dealer/equipment';

@Injectable({
  providedIn: 'root'
})

export class DealerEquipmentService {
  constructor(private http: HttpClient) { }

  // Moves equipments from current dealer to a subdealer
  assignEquipmentsToSubdealer(subdealer_id: number, equipments_ids: number[] ): Observable<Equipment[]> {
    const body = equipments_ids;
    return this.http.post<Equipment[]>(`${basePath}/${subdealer_id}`, body);
  }
}
